import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const DynamicPricingRBAC = {
  pageID: '6e83690841012613ca00f7fd0d344b36',
  elementID: {
    ViewDynamicPricing: 'fbf1e747520006b7959cefb4402ab0e2',
    UpsertDynamicPricing: '63df6e3c9d9841dda67f5b75bc58cc50',
  },
} as const
export const useRBACDynamicPricingPage = createUseRBAC(DynamicPricingRBAC.elementID)
export type UseRBACDynamicPricingPageType = ReturnType<typeof useRBACDynamicPricingPage>

export const DynamicPricingDetailRBAC = {
  pageID: '6b4e94d4c471dffc725d01ee1ae832e9',
  elementID: {
    ViewDynamicPricingDetail: 'ef4da4e8251a6475770021015616f4ca',
    UpsertDynamicPricing: 'a4979934a87bf336cc92d38cc19485cb',
    StopDynamicPricing: 'c93467ed8eb81607c7bb538bf9a61412',
  },
} as const
export const useRBACDynamicPricingDetailPage = createUseRBAC(DynamicPricingDetailRBAC.elementID)
export type UseRBACDynamicPricingDetailPageType = ReturnType<typeof useRBACDynamicPricingDetailPage>

export const DynamicPricingUpsertRBAC = {
  pageID: '6e83690841012613ca00f7fd0d344b36',
  elementID: {
    ViewDynamicPricingUpsert: '099ef5da58be962d6de05c56246f278a',
  },
} as const
export const useRBACDynamicPricingUpsertPage = createUseRBAC(DynamicPricingUpsertRBAC.elementID)
export type UseRBACDynamicPricingUpsertPageType = ReturnType<typeof useRBACDynamicPricingUpsertPage>
